import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  Input,
  Select,
  Space,
  Typography,
  Row,
  Col,
  Form,
  message,
  Spin,
} from "antd";

import { notificationErroInternalGeneric } from "util/api-utils";
import {
  getCompanies,
  updateCompany,
} from "services/managerial/managerial-service";
import { useDebounce } from "views/util/debounce";
import HistoricCommentBox from "./painel-company-history-comment";
import DocumentUploadBox from "./painel-company-document";

const { Text } = Typography;

export default function CompanyDetailBody({
  empresaSel,
  setEmpresaSel,
  setEmpresas,
  ESTADOS,
  FAIXAS,
  uploadProps,
  openPdf,
  isView,
  typeView,
}) {
  const [loading, setLoading] = useState(false);
  const DEBOUNCE_MS = 800;

  const doPersist = useCallback(
    async (all) => {
      try {
        await updateCompany(empresaSel.id, all);
        const result = await getCompanies();
        setEmpresaSel((s) => ({ ...s, ...all }));
        setEmpresas(result);
        message.info("Dados atualizado com sucesso!");
      } catch {
        notificationErroInternalGeneric();
      } finally {
      }
    },
    [empresaSel.id, setEmpresaSel, setEmpresas]
  );
  const debouncedPersist = useDebounce(doPersist, DEBOUNCE_MS);

  useEffect(() => {
    return () => debouncedPersist.cancel();
  }, [debouncedPersist]);

  const onValuesChange = useCallback(
    (_, all) => {
      debouncedPersist(all);
    },
    [debouncedPersist]
  );
  const onBlurFlush = useCallback(() => {
    debouncedPersist.flush();
  }, [debouncedPersist]);

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <Spin spinning={loading}>
        <Row gutter={12}>
          <Col span={12}>
            <Card size="small" onBlur={onBlurFlush}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Text type="secondary">Cadastro</Text>
                <Form
                  layout="vertical"
                  initialValues={empresaSel}
                  onValuesChange={onValuesChange}
                >
                  <Form.Item label="Empresa" name="name">
                    {isView ? <Text>{empresaSel.name}</Text> : <Input />}
                  </Form.Item>
                  <Form.Item label="CNPJ" name="document">
                    {isView ? <Text>{empresaSel.document}</Text> : <Input />}
                  </Form.Item>
                  <Form.Item label="Estado" name="state">
                    {isView ? (
                      <Text>{empresaSel.state}</Text>
                    ) : (
                      <Select
                        options={ESTADOS.map((e) => ({ value: e, label: e }))}
                      />
                    )}
                  </Form.Item>
                  <Form.Item label="Faturamento" name="billing">
                    {isView ? (
                      <Text>{empresaSel.billing}</Text>
                    ) : (
                      <Select
                        options={FAIXAS.map((f) => ({ value: f, label: f }))}
                      />
                    )}
                  </Form.Item>
                </Form>
              </Space>
            </Card>
          </Col>

          <Col span={12}>
            <Card size="small" style={{ minHeight: 400, maxHeight: 400, overflow: "auto"}}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Text type="secondary">Relatórios</Text>
                <Form layout="vertical" onValuesChange={onValuesChange}>
                  <Form.Item
                    label="Anotações"
                    name="note"
                    initialValue={empresaSel.note}
                  >
                    {isView ? (
                      <Text style={{ whiteSpace: "pre-wrap" }}>
                        {empresaSel.note}
                      </Text>
                    ) : (
                      <Input.TextArea
                        rows={12}
                        placeholder="Escreva aqui..."
                        style={{ padding: 12 }}
                      />
                    )}
                  </Form.Item>
                </Form>
              </Space>
            </Card>
          </Col>
        </Row>

        {typeView == "HISTORY" && (
          <HistoricCommentBox companyId={empresaSel.id} />
        )}
        {typeView == "CRUD" && (
          <DocumentUploadBox companyId={empresaSel.id} isView={isView} />
        )}
      </Spin>
    </div>
  );
}
